import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HorseResponse} from '../../models/response.module';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-horse-card',
  standalone: false,
  templateUrl: './horse-card.html',
  styleUrl: './horse-card.css'
})
export class HorseCard implements OnInit {
  @Input() horse: HorseResponse
  @Output() editHorseClick = new EventEmitter<HorseResponse>();
  @Output() deleteHorseClick = new EventEmitter<HorseResponse>();

  horseGenders: { label: string; value: number }[] = [];
  horseRegistries: { label: string; value: number }[] = [];

  constructor(private router: Router,
              private translateService: TranslateService) {
  }

  ngOnInit() {
    this.initDropdowns();
    this.translateService.onLangChange.subscribe(() => {
      this.initDropdowns();
    });
  }

  private initDropdowns() {
    this.horseGenders = [
      { label: this.translateService.instant('horses.gender.gelding'), value: 0 },
      { label: this.translateService.instant('horses.gender.stallion'), value: 1 },
      { label: this.translateService.instant('horses.gender.mare'), value: 2 },
    ];
    this.horseRegistries = [
      { label: 'AQHA', value: 0 },
      { label: 'APHA', value: 1 },
      { label: 'ApHC', value: 2 },
      { label: this.translateService.instant('horses.registry.other'), value: 3 },
    ];
  }

  getHorseGenderLabel(genderValue: number): string {
    return this.horseGenders.find(g => g.value === genderValue)?.label || 'Unknown';
  }

  getRegistryLabel(registryId: number): string {
    return this.horseRegistries.find(r => r.value === registryId)?.label || '-';
  }

  getGenderBadgeClass(): string {
    switch (this.horse.gender) {
      case 0: return 'badge-gelding';
      case 1: return 'badge-stallion';
      case 2: return 'badge-mare';
      default: return 'badge-secondary';
    }
  }

  isVaccinationExpired(): boolean {
    if (!this.horse.next_vaccination_date) return false;
    const nextVacc = new Date(this.horse.next_vaccination_date);
    return nextVacc < new Date();
  }

  emitEditHorseClick() {
    this.editHorseClick.emit(this.horse);
  }

  emitDeleteHorseClick() {
    this.deleteHorseClick.emit(this.horse);
  }
}
